import React from 'react';
import GuestPicker from './GuestPicker';

type GuestValue = {
  adults: number | string;
  children: number | string;
};

type FieldProps = {
  meta: {
    error?: string;
    submitFailed: boolean;
  };
  input: {
    value: GuestValue | '';
    onChange: (value: GuestValue) => void;
  };
};

type ReduxFormGuestPickerProps = {
  minTotal: number;
  maxTotal: number;
  tablesDisableChildBookings: boolean;
  required?: boolean;
  onClose?: () => void;
  onFocus?: () => void;
} & FieldProps;

function parseCount(count: string | number): number {
  if (typeof count === 'number') {
    return count;
  }

  return Number.parseInt(count, 10);
}

export function ReduxFormGuestPicker({
  meta,
  required = false,
  input: { value, onChange },
  minTotal,
  maxTotal,
  tablesDisableChildBookings,
  onClose,
  onFocus,
}: ReduxFormGuestPickerProps) {
  // Defense-in-depth: handle null values from API (JS default params don't apply for null)
  const resolvedMinTotal = minTotal ?? 1;
  const resolvedMaxTotal = maxTotal ?? 100;

  if (value === '') {
    return null;
  }

  const isErrorDisplayed = !!meta.error && meta.submitFailed;
  const children = parseCount(value.children);
  const adults = parseCount(value.adults);
  const intValues = { adults, children };

  return (
    <GuestPicker
      required={required}
      numberOfAdults={adults}
      numberOfChildren={children}
      onGuestCountChange={(type: 'adults' | 'children', amount: number) =>
        onChange({
          ...intValues,
          [type]: intValues[type] + amount,
        })
      }
      onFocus={onFocus}
      onClose={onClose}
      error={isErrorDisplayed ? meta.error : ''}
      disabledPlus={resolvedMaxTotal <= adults + children}
      disabledMinus={resolvedMinTotal >= adults + children}
      isSingle={tablesDisableChildBookings}
      rooms={[{ roomNumber: 1, adults, children }]}
      onRoomCountChange={() => {}}
    />
  );
}
